<template>
  <div id="pick-material-task">
    <div style="width:100%;heigh:100%;">
      <el-card class="table_searchbar">
        <el-row :gutter="20">
          <el-col :span="5">
            <div @keydown.enter="btnSearch()" class="span_flex">
              <span class="title">领料单号：</span>
              <el-input style="max-width:180px" size="small" v-model="searchForm.materialRequisitionCode" placeholder="领料单号"></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">工单号：</span>
              <el-input style="max-width:180px" size="small" v-model="searchForm.productionBatchCode" placeholder="工单号"></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">物料名称：</span>
              <el-input style="max-width:180px" size="small" v-model="searchForm.materialName" placeholder="物料名称"></el-input>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="">
              <span class="title">物料编码：</span>
              <el-input style="max-width:180px" size="small" v-model="searchForm.materialCode" placeholder="物料编码"></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div style="text-align:right">
              <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                {{ showMore ? "收起" : "展开" }}
                <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </a>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
              <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
            </div>
          </el-col>
        </el-row>
        <el-collapse-transition>
          <div v-show="showMore">
            <el-row :gutter="20">
              <el-col :span="span">
                <div class="" @keydown.enter="btnSearch()">
                  <span class="title">任务状态：</span>
                  <el-select size="small" style="max-width:180px;" v-model="searchForm.status" placeholder="任务状态" clearable>
                    <el-option v-for="item in statusOption" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="span">
                <div class="" @keydown.enter="btnSearch()">
                  <span class="title" style="width:112px;margin-left:-30px">生产制单时间：</span>
                  <el-date-picker style="max-width:180px;" v-model="searchForm.makingTime" type="date" value-format="yyyy-MM-dd" placeholder="生产制单时间"></el-date-picker>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-transition>
      </el-card>
      <el-card class="table-card">
        <el-table :data="tableData" style="width: 100%" class="deviceTable">
          <el-table-column prop="materialRequisitionCode" label="领料单号" min-width="160"></el-table-column>
          <el-table-column prop="productionBatchCode" label="工单号" min-width="120"></el-table-column>
          <el-table-column prop="materialCode" label="物料编码" min-width="110"></el-table-column>
          <el-table-column prop="materialName" label="物料名称" min-width="110"></el-table-column>
          <el-table-column prop="specification" label="规格" min-width="110"></el-table-column>
          <el-table-column prop="splitCount" label="生产数量" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="factoryModelName" label="生产机组" min-width="110" show-overflow-tooltip></el-table-column>
          <el-table-column prop="makingTime" label="生产制单时间" min-width="110"></el-table-column>
          <el-table-column prop="planStartTime" label="计划开始时间" min-width="110"></el-table-column>
          <el-table-column prop="status" label="状态" min-width="90" :formatter="parseStatus"></el-table-column>
          <el-table-column prop="gmtModified" label="更新开始时间" min-width="110"></el-table-column>
          <el-table-column label="操作" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button type="text" v-if="permission.btn_materialRequisition_getDetails" @click="showViewDialog(scope.row)" size="small">查看详情</el-button>
              <el-button type="text" v-if="permission.btn_materialRequisition_getPickMaterialDetail && scope.row.status <= 1" @click="showEditDialog(scope.row)" size="small">出库</el-button>
              <el-button v-if="permission.btn_materialRequisition_getDetails" type="text" @click="printOrder(scope.row)" size="small">打印</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page" v-if="tableData.length > 0">
          <div class="total_page">
            <span> 共{{ tableTotalPage }}条 10条/页</span>
          </div>
          <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
            <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"> </el-pagination>
          </div>
        </div>
      </el-card>
      <!-- 查看入库详情开始 -->
      <el-dialog title="领料单详情" @close="cancelViewDialog" :visible.sync="viewDialogVisible" :width="span == 5 ? '58%' : '77%'" center :close-on-click-modal="false">
        <el-row style="margin-top:20px;">
          <el-col :span="5">
            <div class="">
              <span class="title">领料单号：</span>
              <span class="value">{{ selectRow.materialRequisitionCode }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="">
              <span class="title">生产数量：</span>
              <span class="value">{{ selectRow.splitCount }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="">
              <span class="title">物料名称：</span>
              <span class="value">{{ selectRow.materialName }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="">
              <span class="title">物料编码：</span>
              <span class="value">{{ selectRow.materialCode }}</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="">
              <span class="title">规格：</span>
              <span class="value">{{ selectRow.specification }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top:20px;">
          <el-col :span="5">
            <div class="">
              <span class="title">工单号：</span>
              <span class="value">{{ selectRow.productionBatchCode }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="">
              <span class="title">生产机组：</span>
              <span class="value">{{ selectRow.factoryModelName }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="">
              <span class="title">制单时间：</span>
              <span class="value">{{ selectRow.makingTime }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="">
              <span class="title">计划时间：</span>
              <span class="value">{{ selectRow.planStartTime }}{{ selectRow.planEndTime ? "——" + selectRow.planEndTime : "" }}</span>
            </div>
          </el-col>
        </el-row>

        <el-table :data="stockInDetailList" stripe style="width: 100%">
          <el-table-column prop="materialCode" label="物料编码" min-width="100"></el-table-column>
          <el-table-column prop="materialName" label="物料名称" min-width="100"></el-table-column>
          <el-table-column prop="specification" label="规格" min-width="110"></el-table-column>
          <el-table-column prop="needAmount" label="需求数量" min-width="60"></el-table-column>
          <el-table-column prop="unitType" label="单位" min-width="50"></el-table-column>
          <el-table-column prop="warehouseName" label="仓库" min-width="120"></el-table-column>
          <el-table-column prop="stockAmount" label="库存数量" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="pickAmount" label="已领数量" min-width="60" show-overflow-tooltip></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelViewDialog" type="primary">确 定</el-button>
          <el-button @click="printOrder(selectRow, 1)" type="primary">打 印</el-button>
        </span>
      </el-dialog>
      <!-- 新增入库详情结束 -->

      <!-- 来料出库详情开始 -->
      <el-dialog title="领料出库" @close="cancelViewDialog" :visible.sync="editDialogVisible" :width="span == 5 ? '68%' : '80%'" center :close-on-click-modal="false">
        <el-form :model="editForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form">
          <el-row style="margin-top:20px;">
            <el-col :span="5">
              <div class="">
                <span class="title">领料单号：</span>
                <span class="value">{{ selectRow.materialRequisitionCode }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="">
                <span class="title">生产数量：</span>
                <span class="value">{{ selectRow.splitCount }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="">
                <span class="title">物料名称：</span>
                <span class="value">{{ selectRow.materialName }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="">
                <span class="title">物料编码：</span>
                <span class="value">{{ selectRow.materialCode }}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="">
                <span class="title">规格：</span>
                <span class="value">{{ selectRow.specification }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row style="margin-top:20px;">
            <el-col :span="5">
              <div class="">
                <span class="title">工单号：</span>
                <span class="value">{{ selectRow.productionBatchCode }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="">
                <span class="title">生产机组：</span>
                <span class="value">{{ selectRow.factoryModelName }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="">
                <span class="title">制单时间：</span>
                <span class="value">{{ selectRow.makingTime }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="">
                <span class="title">计划时间：</span>
                <span class="value">{{ selectRow.planStartTime }}{{ selectRow.planEndTime ? "——" + selectRow.planEndTime : "" }}</span>
              </div>
            </el-col>
          </el-row>

          <el-table border :data="stockOutDetailList" stripe style="width: 100%" :span-method="arraySpanMethod">
            <el-table-column prop="materialCode" label="物料编码" min-width="100">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.materialCode }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="materialName" label="物料名称" min-width="100">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.materialName }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="specification" label="规格" min-width="110">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.specification }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="needAmount" label="需求数量" min-width="60">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.needAmount }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="unitType" label="单位" min-width="60">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.unitType }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="itemPickAmount" label="已领数量" min-width="60">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.itemPickAmount }}
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column prop="totalAmount" label="总出库量" min-width="60">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.totalAmount }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="productionBatchCode" label="批次" min-width="110">
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.productionBatchCode }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="factoryName" label="仓库/库位" min-width="110">
              <template slot-scope="scope">
                <el-form-item> {{ scope.row.warehouseName }}/{{ scope.row.factoryName }} </el-form-item>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="warehouseName" label="库位" min-width="110"></el-table-column> -->
            <el-table-column prop="itemAmount" label="库存数量" min-width="60" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-form-item>
                  {{ scope.row.itemAmount }}
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="pickAmount" label="出库数量" min-width="100" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-form-item :prop="`stockOutDetailList[${scope.$index}]`" :rules="rules.pickAmount">
                  <el-input @change="pickAmountChange(scope.row, scope.$index)" v-model="scope.row.pickAmount"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="submitEditDialog" type="primary">确 定</el-button>
          <el-button @click="cancelEditDialog">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 新领料出库详情结束 -->
    </div>
  </div>
</template>

<script>
export default {
  name: "PickMaterialTask",
  data() {
    return {
      orderType: "DESC", //排序类型
      orderColumn: "gmtCreate", //排序列
      defaultSort: { prop: "gmtCreate", order: "descending" }, //默认排序设置
      fristLoad: false,
      editRemark: null,
      selectRow: {},
      showMore: false,
      rules: {
        pickAmount: [
          //出库数量
          { required: false, message: "请输入出库数量", trigger: "blur" },
          {
            validator(rule, item, callback) {
              let value = item.pickAmount;
              if (value) {
                value = Number(value);
                if (!isNaN(value)) {
                  if (Number(value) >= 0) {
                    if (value > item.itemAmount) {
                      callback(new Error("出库数量不能大于库存数量"));
                    } else {
                      if (item.totalAmount + item.itemPickAmount > item.needAmount) {
                        callback(new Error(`总出库数量不能大于可出库数量(${item.needAmount - item.itemPickAmount})`));
                      } else {
                        callback();
                      }
                    }
                  } else {
                    callback(new Error("出库数量不能小于零"));
                  }
                } else {
                  callback(new Error("出库数量必须为数字"));
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      editForm: {
        stockOutDetailList: []
      },
      statusOption: [
        //0未领料,1领料中,2领料完成/3已关闭
        { id: 0, label: "未领料", value: 0 },
        { id: 1, label: "领料中", value: 1 },
        { id: 2, label: "领料完成", value: 2 }
        // { id: 3, label: '已关闭', value: 3 },
      ],
      stockInDetailList: [],
      stockOutDetailList: [],
      showPage: 1,
      viewDialogVisible: false,
      editDialogVisible: false,
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        materialRequisitionCode: "",
        productionBatchCode: "",
        materialCode: "",
        materialName: "",
        status: null,
        makingTime: null,
        factoryModelId: null
      },
      tableData: [],
      tableCurrentPage: 1,
      tableTotalPage: 2,

      viewDialogVisible: false,
      data: {
        token: localStorage.getItem("token")
      },
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  mounted: function() {
    this.initTable();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  computed: {
    span() {
      return this.W ? 5 : 6;
    }
  },
  deactivated: function() {
    console.log("deactivated");
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    showHighlight(scope) {
      if (scope.row.hasDeletedUser == 1) {
        return { background: "#FFFFCC" };
      }
    },

    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex <= 6) {
        if (row.len) {
          return [row.len, 1];
        } else {
          return [0, 0];
        }
      }
    },
    pickAmountChange(rowData, i) {
      let num = rowData.num;
      let start = i - rowData.index;
      let total = 0;
      log(rowData, start, i);
      for (let j = 0; j < num; j++) {
        let item = this.stockOutDetailList[start + j];
        log(start, j, Number(item.pickAmount), total);
        total += Number(item.pickAmount);
      }
      for (let j = 0; j < num; j++) {
        let item = this.stockOutDetailList[start + j];
        item.totalAmount = total;
      }
    },

    reload() {
      this.initTable();
    },

    async loadStockInDetail(materialRequisitionId) {
      let res = await this.$RequestUtil.getAsync({ url: "/api/materialRequisition/getDetails", type: "sync", params: { materialRequisitionId } });
      if (res.code == 0) {
        this.stockInDetailList = res.data;
      } else {
        this.$message.error(res.msg || res, message);
      }
    },

    cancelViewDialog() {
      this.viewDialogVisible = false;
      this.selectRow = {};
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },
    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.materialRequisitionCode = "";
      form.productionBatchCode = "";
      form.materialCode = "";
      form.materialName = "";
      form.status = null;
      form.makingTime = null;
      form.factoryModelId = null;
    },
    search: function() {
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            materialRequisitionCode: "",
            productionBatchCode: "",
            materialCode: "",
            materialName: "",
            status: null,
            makingTime: null,
            factoryModelId: null
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      this.$RequestUtil.get({
        url: "/api/materialRequisition/list",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 10,
          materialRequisitionCode: temp.materialRequisitionCode,
          productionBatchCode: temp.productionBatchCode,
          materialCode: temp.materialCode,
          materialName: temp.materialName,
          status: temp.status,
          makingTime: temp.makingTime,
          factoryModelId: temp.factoryModelId
        },
        success: res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },
    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },
    initTable: function() {
      this.search();
    },

    async showViewDialog(rowData) {
      await this.loadStockInDetail(rowData.materialRequisitionId);
      this.viewDialogVisible = true;
      this.selectRow = rowData;
    },

    submitEditDialog() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          let pickMaterialVOs = [];
          this.editForm.stockOutDetailList.forEach((item, i) => {
            if (item.len > 0) {
              let arr = this.editForm.stockOutDetailList.slice(i, item.len + i);
              pickMaterialVOs.push(arr);
            }
          });
          let arr2 = [];
          pickMaterialVOs = pickMaterialVOs.map(item => {
            let json = {
              pickMaterialId: item[0].pickMaterialId,
              materialId: item[0].materialId,
              pickAmount: item[0].totalAmount
            };
            let stockVOs = item.map(sub => {
              return { stockId: sub.stockId, stockPickAmount: sub.pickAmount };
            });
            json.stockVOs = stockVOs;
            return json;
          });

          this.$RequestUtil.post({
            url: "/api/materialRequisition/webSubmit",
            type: "sync",
            params: {
              pickMaterialVOs,
              materialRequisitionId: this.editForm.materialRequisitionId
            },
            success: res => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.initTable();
                this.cancelEditDialog();
              } else {
                this.$message.error(res.message);
              }
            }
          });
        }
      });
    },
    cancelEditDialog() {
      this.editDialogVisible = false;
    },
    async showEditDialog(rowData) {
      await this.loadStockOutDetail(rowData.materialRequisitionId);
      this.editForm.materialRequisitionId = rowData.materialRequisitionId;
      this.editDialogVisible = true;
      this.selectRow = rowData;
    },

    async loadStockOutDetail(materialRequisitionId) {
      let res = await this.$RequestUtil.getAsync({ url: "/api/materialRequisition/getPickMaterialDetail", type: "sync", params: { materialRequisitionId } });
      if (res.code == 0) {
        let arr = [];
        res.data.forEach(item => {
          item.stockDtos.forEach((sub, index) => {
            let len = 0;
            let json = {
              ...sub
            };
            if (index == 0) {
              len = item.stockDtos.length;
            }
            json.index = index;
            json.num = item.stockDtos.length;
            json.len = len;
            json.materialId = item.materialId;
            json.itemPickAmount = item.pickAmount;
            json.pickMaterialId = item.pickMaterialId;
            json.materialName = item.materialName;
            json.materialCode = item.materialCode;
            json.specification = item.specification;
            json.needAmount = item.needAmount;
            json.pickAmount = 0;
            json.totalAmount = 0;
            json.unitType = item.unitType;
            arr.push(json);
          });
        });
        this.stockOutDetailList = arr;
        this.editForm.stockOutDetailList = arr;
      } else {
        this.$message.error(res.msg || res, message);
      }
    },

    async printOrder(rowData, type) {
      let StockOutInfo = commonUtils.cloneObj(rowData);
      if (type != 1) {
        await this.loadStockInDetail(rowData.materialRequisitionId);
      }

      StockOutInfo.stockInDetailList = this.stockInDetailList;
      localStorage.setItem("printStockInfo", JSON.stringify(StockOutInfo));
      let routeUrl = this.$router.resolve({ path: "/Print/PrintPickMaterial" });
      window.open(routeUrl.href, "_blank");
    },

    parseStatus(rowData) {
      return (this.statusOption.find(item => item.id == rowData.status) || {}).label;
    }
  }
};
</script>

<style scoped>
.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}

.add_form .value {
  display: inline-block;
}

.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}

.import_upload {
  display: inline;
}

.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}

@media screen and (max-width: 1366px) {
  #pick-material-task .el-date-editor.el-input,
  #pick-material-task .el-date-editor.el-input__inner {
    width: 176px !important;
  }
}

@media screen and (min-width: 1400px) and (max-width: 1920px) {
  .y_records_width {
    width: 220px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/stock/PickMaterialTask.vue